import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import rootReducer from '../reducers'

const loggerMiddleware = createLogger()

export default function configureStore(preloadedState) {

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  var isDev = (typeof __IS_DEV__ == 'undefined')?'0':__IS_DEV__;

  if(isDev === '1'){
    return createStore(
      rootReducer,
      preloadedState,
      composeEnhancers(applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
      ))
    )
  }else{
    return createStore(
      rootReducer,
      preloadedState,
      composeEnhancers(applyMiddleware(
        thunkMiddleware
      ))
    )
  }

}



// WEBPACK FOOTER //
// ./src/store/index.js